export default "__VITE_ASSET__C5aH4DNH__"